/* Algolia Custom Hooks
 *
 * InstantSearch hook — beforeInstantSearchProductTemplate:
 *   handler(defaultTemplate, hit, html, components)
 *   Rendered by InstantSearch.js's own (mustache-style) templating, which
 *   inserts a returned string as raw HTML, so a plain string works fine.
 *
 * Autocomplete hook — beforeAutocompleteProductTemplate:
 *   handler(defaultTemplate, templateOptions, item)
 *   templateOptions.html is a tagged-template-literal helper (Preact/htm).
 *   Autocomplete's renderer is VDOM-based: a plain string gets treated as
 *   a text node and shows up as literal, escaped markup in the dropdown
 *   (the bug we hit), so the item template MUST be built with that html
 *   helper instead of string concatenation.
 *
 * Card markup below mirrors snippets/card-product.liquid so the theme's
 * existing CSS (product-card, f-price, f-badge, btn) applies unchanged.
 * Style-dependent classes (pcard_style, color scheme, button style, etc.)
 * come from window.themeProductCardSettings, set in layout/theme.liquid,
 * so this stays in sync with the merchant's actual theme settings.
 */
document.addEventListener("algolia.hooks.initialize", function () {

  var pcard           = window.themeProductCardSettings || {};
  var cardStyle       = pcard.style || 'standard';
  var colorScheme     = pcard.colorScheme || 'scheme-2';
  var overlayScheme   = pcard.overlayColorScheme || 'scheme-1';
  // var buttonStyle     = pcard.buttonStyle || 'btn--primary';
  var contentAlign    = pcard.contentAlignment || 'left';
  var titleLineLimit  = pcard.titleLineLimit || '2-lines';
  var showPrice       = pcard.showPrice !== false;
  var showSaleBadge   = !!pcard.showSaleBadge;
  var addToCartText   = pcard.addToCartText || 'Add to cart';
  var onSaleText      = pcard.onSaleText || 'Sale';
  var liquidacionText = pcard.liquidacionText || 'Liquidación';
  var oportunidadText = pcard.oportunidadText || 'Oportunidad';
  var soldOutText     = pcard.soldOutText || 'Sold out';
  var newTagHandles    = Array.isArray(pcard.newTagHandles) ? pcard.newTagHandles : [];
  var hotTagHandles    = Array.isArray(pcard.hotTagHandles) ? pcard.hotTagHandles : [];
  var comingTagHandles = Array.isArray(pcard.comingTagHandles) ? pcard.comingTagHandles : [];
  var cartIconSvg     = pcard.cartIconSvg || '';

  // Mirrors Shopify's Liquid `| handleize` filter, which normalizes
  // accented characters (í → i, ñ → n, etc.) BEFORE hyphenating —
  // "Descuento en Línea" must become "descuento-en-linea" to match the
  // real f-badge--descuento-en-linea CSS class, not "descuento-en-l-nea".
  var ACCENT_MAP = {
    'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'ü': 'u', 'ñ': 'n',
    'Á': 'a', 'É': 'e', 'Í': 'i', 'Ó': 'o', 'Ú': 'u', 'Ü': 'u', 'Ñ': 'n'
  };
  function handleize(str) {
    return String(str || '')
      .replace(/[áéíóúüñÁÉÍÓÚÜÑ]/g, function (c) { return ACCENT_MAP[c] || c; })
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /* ------------------------------------------------------------------
   * Price formatter
   * This index's hit records don't carry price_formatted /
   * compare_at_price_formatted (confirmed via runtime inspection), only
   * plain decimal price/compare_at_price. So we format using the theme's
   * own FoxTheme.Currency.formatMoney + the shop's configured money
   * format (window.FoxTheme.settings.moneyFormat, from js-variables.liquid)
   * — the exact same formatting the rest of the theme uses.
   * ------------------------------------------------------------------ */
  function formatPrice(formatted, raw) {
    if (formatted) return formatted;
    if (raw == null || raw === '') return '';
    var n = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
    if (isNaN(n)) return String(raw);
    try {
      if (window.FoxTheme && FoxTheme.Currency && typeof FoxTheme.Currency.formatMoney === 'function') {
        var format = FoxTheme.settings && FoxTheme.settings.moneyFormat;
        return FoxTheme.Currency.formatMoney(Math.round(n * 100), format);
      }
    } catch (e) {}
    return n.toFixed(2);
  }

  /* ------------------------------------------------------------------
   * Image URL: tries algoliaShopify helpers first, then fallbacks
   * ------------------------------------------------------------------ */
  function getImage(hit) {
    try {
      if (window.algoliaShopify && algoliaShopify.helpers && algoliaShopify.helpers.mediumImage) {
        var img = algoliaShopify.helpers.mediumImage(hit);
        if (img) return img;
      }
    } catch (e) { console.warn('[Algolia] mediumImage error:', e); }
    return hit.product_image || hit.image || hit.image_url
        || hit.src || hit.featured_image
        || (Array.isArray(hit.images) && hit.images[0]
              ? (typeof hit.images[0] === 'string' ? hit.images[0] : (hit.images[0].src || ''))
              : '')
        || '';
  }

  /* ------------------------------------------------------------------
   * Product URL
   * ------------------------------------------------------------------ */
  function getUrl(hit) {
    if (hit.url) return hit.url;
    if (hit.path) return hit.path;
    if (hit.handle) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.replace(/\/$/, '') + '/products/' + hit.handle;
    }
    return '#';
  }

  function getHandle(hit) {
    if (hit.handle) return String(hit.handle);
    if (hit.product_handle) return String(hit.product_handle);
    var path = hit.url || hit.path || '';
    var match = String(path).match(/\/products\/([^/?#]+)/);
    if (!match) return '';
    try { return decodeURIComponent(match[1]); } catch (e) { return match[1]; }
  }

  /* ------------------------------------------------------------------
   * Safe string escape for HTML attributes
   * ------------------------------------------------------------------ */
  function esc(str) {
    return String(str || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  /* ------------------------------------------------------------------
   * Badges — mirrors snippets/pcard-badges.liquid's full logic and order:
   * sold-out, Oportunidad/Liquidación (metafields.magento.tipo_precio),
   * custom offer-tag-text metafield, the additional_badges metafield
   * array, a separate on-sale badge, then new/hot/coming tag matching.
   *
   * Metafields indexed via the Algolia app's "Metafields Indexing" panel
   * land at hit.meta.<namespace>.<key> (confirmed via runtime inspection),
   * e.g. hit.meta.magento.tipo_precio / hit.meta.custom.offer_tag_text /
   * hit.meta.custom.additional_badges — NOT as top-level hit attributes.
   * additional_badges specifically comes through as a JSON-encoded
   * *string* (e.g. '["Novedad","Preferidos"]'), not a real array, so it
   * needs parsing. If a product hasn't set a given metafield, its branch
   * below just no-ops (falls through to the on-sale approximation for
   * tipo_precio, or renders nothing for offer_tag_text/additional_badges).
   * ------------------------------------------------------------------ */
  function buildBadgeHtml(hit, onSale) {
    var badges = [];

    // Confirmed via runtime inspection: indexed metafields land at
    // hit.meta.<namespace>.<key> (matching the namespace/key columns in
    // the Algolia app's Metafields Indexing settings), not as top-level
    // attributes. additional_badges specifically comes through as a
    // JSON-*string* (e.g. '["Novedad","Preferidos"]'), not a real array.
    var meta = hit.meta || {};
    var metaCustom = meta.custom || {};
    var metaMagento = meta.magento || {};

    if (hit.inventory_available === false) {
      badges.push('<span class="f-badge f-badge--soldout" aria-hidden="true">' + esc(soldOutText) + '</span>');
    }

    var tipoPrecio = String(metaMagento.tipo_precio || '').toLowerCase();
    if (tipoPrecio === 'o') {
      badges.push('<span class="f-badge f-badge--oportunidad" aria-hidden="true">' + esc(oportunidadText) + '</span>');
    } else if (tipoPrecio === 'l') {
      badges.push('<span class="f-badge f-badge--liquidacion" aria-hidden="true">' + esc(liquidacionText) + '</span>');
    } else if (onSale) {
      // No tipo_precio value on this hit — approximate the native
      // Liquidación badge using the on-sale condition instead.
      badges.push('<span class="f-badge f-badge--liquidacion" aria-hidden="true">' + esc(liquidacionText) + '</span>');
    }

    var offerTagText = metaCustom.offer_tag_text;
    if (offerTagText) {
      badges.push('<span class="f-badge f-badge--tag_text" aria-hidden="true">' + esc(String(offerTagText).toLowerCase()) + '</span>');
    }

    var additionalBadges = metaCustom.additional_badges;
    if (typeof additionalBadges === 'string') {
      try { additionalBadges = JSON.parse(additionalBadges); } catch (e) { additionalBadges = []; }
    }
    if (!Array.isArray(additionalBadges)) additionalBadges = [];
    additionalBadges.forEach(function (badge) {
      badges.push('<span class="f-badge f-badge--multi-meta-tag f-badge--' + handleize(badge) + '">' + esc(badge) + '</span>');
    });

    if (showSaleBadge && onSale && hit.inventory_available !== false) {
      badges.push('<span class="f-badge f-badge--sale" aria-hidden="true">' + esc(onSaleText) + '</span>');
    }

    var tags = Array.isArray(hit.tags) ? hit.tags : [];
    tags.forEach(function (tag) {
      var tagHandle = handleize(tag);
      if (newTagHandles.indexOf(tagHandle) > -1) {
        badges.push('<span class="f-badge f-badge--new">' + esc(tag) + '</span>');
      } else if (hotTagHandles.indexOf(tagHandle) > -1) {
        badges.push('<span class="f-badge f-badge--hot">' + esc(tag) + '</span>');
      } else if (comingTagHandles.indexOf(tagHandle) > -1) {
        badges.push('<span class="f-badge f-badge--coming">' + esc(tag) + '</span>');
      }
    });

    return badges.length ? '<div class="product-card__badge">' + badges.join('') + '</div>' : '';
  }

  function buildAlgoliaAtcButton(hit) {
    var handle = getHandle(hit);
    var variantId = getHitVariantId(hit);
    var soldOut = hit.inventory_available === false;
    return '<button type="button" class="product-card__atc product-card__action-button btn btn--primary" data-epa-algolia-atc data-product-handle="' + esc(handle) + '" data-product-variant-id="' + esc(variantId) + '"' + (soldOut ? ' disabled aria-disabled="true"' : '') + '>'
      + '<div class="btn__text flex gap-1 items-center">'
        + '<span class="product-card__atc-icon product-card__action-icon inline-flex md:hidden">' + cartIconSvg + '</span>'
        + '<span class="product-card__atc-text product-card__action-text">' + esc(soldOut ? soldOutText : addToCartText) + '</span>'
      + '</div>'
      + '<div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle></svg></div>'
    + '</button>';
  }

  /* ------------------------------------------------------------------
   * Tax extraction and calculation
   * Mirrors PDP collection-based tax calculation (Gravado 13%, 15%, Exentos).
   * ------------------------------------------------------------------ */
  function extractTaxPercentage(text) {
    if (!text || typeof text !== 'string') return null;
    var lower = text.toLowerCase().trim();
    if (lower.indexOf('exentos') > -1) return 0;
    if (lower.indexOf('gravado') > -1) {
      var match = lower.match(/gravado[^\d]*(\d+(?:\.\d+)?)/i);
      if (match && match[1]) {
        var num = parseFloat(match[1]);
        if (!isNaN(num) && num > 0) return num;
      }
    }
    return null;
  }

  function getHitTaxPercentage(hit) {
    if (!hit) return 0;

    var collections = hit.collections || hit.collection_titles || hit.collection_names;
    if (collections) {
      var list = Array.isArray(collections) ? collections : [collections];
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        var title = typeof item === 'string' ? item : (item && (item.title || item.name || item.handle || ''));
        var tax = extractTaxPercentage(title);
        if (tax !== null) return tax;
      }
    }

    if (hit.tags) {
      var tags = Array.isArray(hit.tags) ? hit.tags : String(hit.tags).split(',');
      for (var j = 0; j < tags.length; j++) {
        var tagTax = extractTaxPercentage(tags[j]);
        if (tagTax !== null) return tagTax;
      }
    }

    if (hit.named_tags) {
      for (var key in hit.named_tags) {
        if (Object.prototype.hasOwnProperty.call(hit.named_tags, key)) {
          var val = hit.named_tags[key];
          var vals = Array.isArray(val) ? val : [val];
          for (var k = 0; k < vals.length; k++) {
            var namedTax = extractTaxPercentage(key + ' ' + vals[k]);
            if (namedTax !== null) return namedTax;
          }
        }
      }
    }

    return 0;
  }

  // The Algolia index may omit the Magento conversion metafields. Use the
  // same Shopify-rendered price data as the product page so search results
  // always show the m² price when available and the tax-inclusive price
  // otherwise.
  var canonicalPriceCache = {};
  var canonicalPriceRequests = {};

  function getHitPrices(hit) {
    // Prefer the canonical, Shopify-rendered price once we've already
    // fetched it for this handle (see fetchCanonicalPrice/enrichAlgoliaPrices
    // below). Without this, every fresh DOM node — which the autocomplete
    // dropdown creates on every keystroke — re-renders from the raw,
    // un-converted/un-taxed hit.price first and only gets corrected later
    // if that node is still mounted when the async fetch resolves. Since
    // the dropdown tears down and rebuilds nodes far faster than the
    // instant-search results grid, that correction almost never lands in
    // time there, which is why the autocomplete price looked permanently
    // different from the results-page price for the same product.
    var cachedHandle = getHandle(hit);
    var cachedPricing = cachedHandle ? canonicalPriceCache[cachedHandle] : null;
    if (cachedPricing && cachedPricing.price) {
      return {
        numPrice: null,
        numCompare: null,
        finalPrice: null,
        finalCompare: null,
        onSale: cachedPricing.onSale,
        price: cachedPricing.price,
        compare: cachedPricing.compare,
        taxPercentage: null,
        showM2Price: cachedPricing.showM2Price
      };
    }

    var numPrice   = parseFloat(String(hit.price || hit.variants_min_price || '').replace(/[^0-9.]/g, '')) || 0;
    var numCompare = parseFloat(String(hit.compare_at_price || hit.variants_compare_at_price_min || '').replace(/[^0-9.]/g, '')) || 0;

    var taxPercentage = getHitTaxPercentage(hit);
    var taxRate       = taxPercentage > 0 ? (taxPercentage / 100.0) : 0;

    var finalPrice    = taxRate > 0 && numPrice > 0 ? (numPrice * (1 + taxRate)) : numPrice;
    var finalCompare  = taxRate > 0 && numCompare > 0 ? (numCompare * (1 + taxRate)) : numCompare;

    // MTK products are sold by the box, but the storefront displays the
    // converted per-square-metre price. Algolia indexes these metafields
    // under hit.meta.magento, just like the badge metafields above.
    var magentoMeta = hit.meta && hit.meta.magento ? hit.meta.magento : {};
    var unidadConversion = String(magentoMeta.unidad_conversion || '').trim().toUpperCase();
    var factorConversion = parseFloat(String(magentoMeta.factor_conversion || '').replace(/[^0-9.]/g, '')) || 0;
    var showM2Price = unidadConversion === 'MTK' && factorConversion > 0;

    if (showM2Price) {
      finalPrice = finalPrice / factorConversion;
      if (finalCompare > 0) finalCompare = finalCompare / factorConversion;
    }

    var onSale        = finalCompare > 0 && finalCompare > finalPrice;
    var price         = formatPrice(null, finalPrice);
    var compare       = formatPrice(null, finalCompare);

    return {
      numPrice: numPrice,
      numCompare: numCompare,
      finalPrice: finalPrice,
      finalCompare: finalCompare,
      onSale: onSale,
      price: price,
      compare: compare,
      taxPercentage: taxPercentage,
      showM2Price: showM2Price
    };
  }

  /* ------------------------------------------------------------------
   * InstantSearch product card HTML
   * Mirrors card-product.liquid structure exactly so theme CSS applies.
   * ------------------------------------------------------------------ */
  function buildCard(hit) {
    var title      = hit.title || hit.name || '';
    var url        = getUrl(hit);
    var image      = getImage(hit);

    var prices     = getHitPrices(hit);
    var price      = prices.price;
    var compare    = prices.compare;
    var onSale     = prices.onSale;
    var priceUnit  = prices.showM2Price ? '<span class="price-unit">x m<sup>2</sup></span>' : '';

    // Track attribution safely
    try {
      if (window.algoliaShopify && algoliaShopify.trackSearchAttribution) {
        algoliaShopify.trackSearchAttribution(hit);
      }
    } catch(e) {}

    var imgHtml = image
      ? '<img src="' + esc(image) + '" alt="' + esc(title) + '" loading="lazy" class="motion-reduce">'
      : '';

    var badgeHtml = buildBadgeHtml(hit, onSale);
    var atcButtonHtml = buildAlgoliaAtcButton(hit);

    var priceHtml = '';
    if (showPrice) {
      priceHtml = '<div class="f-price' + (contentAlign ? ' f-price--' + contentAlign : '') + (onSale ? ' f-price--on-sale' : '') + '" data-epa-price-handle="' + esc(getHandle(hit)) + '">'
        + '<div class="f-price__regular">'
          + '<span class="f-price-item f-price-item--regular">' + (onSale ? '' : price + priceUnit) + '</span>'
        + '</div>'
        + '<div class="f-price__sale">'
          + '<span class="f-price-item f-price-item--sale">' + (onSale ? price + priceUnit : '') + '</span>'
          + '<span class="f-price-item f-price-item--regular"><s>' + (onSale ? compare : '') + '</s>' + (onSale ? priceUnit : '') + '</span>'
        + '</div>'
      + '</div>';
    }

    var cardClass = 'product-card product-card-style-' + cardStyle
      + (cardStyle === 'card' ? ' color-' + colorScheme : '');

    return '<div class="' + cardClass + '">'
      + '<div class="product-card__wrapper h-full">'
        + '<div class="product-card__image-wrapper product-card__image-wrapper--main-only color-' + overlayScheme + ' bg-none">'
          + '<a href="' + esc(url) + '" aria-label="' + esc(title) + '" tabindex="-1">'
            + '<div class="media-wrapper product-card__image product-card__image--main" style="--aspect-ratio:1;">'
              + imgHtml
            + '</div>'
          + '</a>'
          + badgeHtml
          + '<div class="product-card__actions product-card__main-actions no-js-hidden">'
            + atcButtonHtml
          + '</div>'
        + '</div>'
        + '<div class="product-card__info text-' + esc(contentAlign) + '">'
          + '<h3 class="product-card__title text-pcard-title">'
            + '<a class="reversed-link block' + (titleLineLimit !== 'none' ? ' text-limit-' + titleLineLimit : '') + '" href="' + esc(url) + '">'
              + '<span class="reversed-link__text">' + esc(title) + '</span>'
            + '</a>'
          + '</h3>'
          + priceHtml
        + '</div>'
        + '<div class="product-card__list-actions">'
          + atcButtonHtml
          + '<a class="ais-view-details btn btn--secondary" href="' + esc(url) + '"><span class="btn__text">Ver Detalles</span></a>'
        + '</div>'
      + '</div>'
    + '</div>';
  }

  function getHitVariantId(hit) {
    var directIds = [hit.variant_id, hit.selected_variant_id, hit.first_available_variant_id];
    for (var i = 0; i < directIds.length; i++) {
      if (directIds[i] != null && directIds[i] !== '') return String(directIds[i]);
    }

    var variants = hit.variants || hit.variants_data;
    if (!Array.isArray(variants)) return '';
    var variant = variants.find(function (item) {
      return item && typeof item === 'object' && item.id && item.available !== false;
    }) || variants.find(function (item) { return item && typeof item === 'object' && item.id; });
    return variant ? String(variant.id) : '';
  }

  function fetchProductVariantId(handle) {
    if (!handle) return Promise.resolve('');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed: ' + response.status);
        return response.json();
      })
      .then(function (product) {
        var variants = product && Array.isArray(product.variants) ? product.variants : [];
        var variant = variants.find(function (item) { return item && item.available; }) || variants[0];
        return variant && variant.id ? String(variant.id) : '';
      });
  }

  function addAlgoliaProductToCart(button) {
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    var handle = button.getAttribute('data-product-handle');
    var variantId = button.getAttribute('data-product-variant-id') || '';
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('btn--loading');

    var variantPromise = variantId ? Promise.resolve(variantId) : fetchProductVariantId(handle);
    variantPromise
      .then(function (resolvedVariantId) {
        if (!resolvedVariantId) throw new Error('No available product variant found.');

        var cartDrawer = document.querySelector('cart-drawer');
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var cartAddUrl = window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url
          ? FoxTheme.routes.cart_add_url
          : root.replace(/\/?$/, '/') + 'cart/add.js';
        var config = window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig
          ? FoxTheme.utils.fetchConfig('javascript')
          : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
        config.body = JSON.stringify({
          id: resolvedVariantId,
          quantity: 1,
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        });

        return fetch(cartAddUrl, config).then(function (response) {
          return response.json().then(function (result) {
            if (!response.ok || result.status) {
              throw new Error(result.description || 'Could not add this product to the cart.');
            }
            return { product: result, cartDrawer: cartDrawer };
          });
        });
      })
      .then(function (result) {
        var cartUrl = window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url
          ? FoxTheme.routes.cart_url
          : ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
        var cartConfig = window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig
          ? FoxTheme.utils.fetchConfig()
          : { credentials: 'same-origin' };

        return fetch(cartUrl, cartConfig).then(function (response) {
          return response.json().then(function (cart) {
            cart.sections = result.product.sections || {};
            if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            }
            document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: result.product } }));
            if (result.cartDrawer) {
              result.cartDrawer.show(button);
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
            }
          });
        });
      })
      .catch(function (error) {
        console.error('[Algolia] Could not add product to cart:', error);
        document.dispatchEvent(new CustomEvent('product-ajax:error', { detail: { errorMessage: error.message } }));
        if (!document.querySelector('cart-drawer')) window.alert(error.message);
      })
      .finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.classList.remove('btn--loading');
      });
  }

  if (!document.documentElement.hasAttribute('data-epa-algolia-atc-listener')) {
    document.documentElement.setAttribute('data-epa-algolia-atc-listener', 'true');
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-epa-algolia-atc]');
      if (!button) return;
      event.preventDefault();
      addAlgoliaProductToCart(button);
    });
  }

  var algoliaLayoutMode = 'grid';

  function applyAlgoliaLayout() {
    document.querySelectorAll('.ais-Hits-list').forEach(function (list) {
      if (list.dataset.layout !== algoliaLayoutMode) list.dataset.layout = algoliaLayoutMode;
    });
    document.querySelectorAll('.ais-change-display-block, .ais-change-display-list').forEach(function (button) {
      var selected = button.classList.contains('ais-change-display-list')
        ? algoliaLayoutMode === 'list'
        : algoliaLayoutMode === 'grid';
      button.classList.toggle('ais-change-display-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function selectAlgoliaLayout(mode) {
    if (mode !== 'grid' && mode !== 'list') return;
    algoliaLayoutMode = mode;
    applyAlgoliaLayout();
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('.ais-change-display-block, .ais-change-display-list');
    if (!control) return;
    event.preventDefault();
    selectAlgoliaLayout(control.classList.contains('ais-change-display-list') ? 'list' : 'grid');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var control = event.target.closest('.ais-change-display-block, .ais-change-display-list');
    if (!control) return;
    event.preventDefault();
    selectAlgoliaLayout(control.classList.contains('ais-change-display-list') ? 'list' : 'grid');
  });

  var algoliaLayoutObserver = new MutationObserver(applyAlgoliaLayout);
  algoliaLayoutObserver.observe(document.body, { childList: true, subtree: true });
  applyAlgoliaLayout();

  /* ------------------------------------------------------------------
   * Autocomplete (predictive) item HTML
   * Clean row: thumbnail | vendor + title + price
   * Built as ONE top-level `html` tagged-template call with only plain
   * value interpolations — nesting a second html`...` call inside this
   * one (for conditional sub-elements) doesn't render as markup with
   * this helper, it prints as a stray text node. So conditional bits
   * (image/vendor/price) stay in the template and are hidden via style
   * when empty, rather than being included/excluded as separate nodes.
   * ------------------------------------------------------------------ */
  function buildAutoItem(html, hit) {
    var title   = hit.title || hit.name || '';
    var vendor  = hit.vendor || '';
    var url     = getUrl(hit);
    var image   = getImage(hit);
    var prices  = getHitPrices(hit);
    var price   = prices.price;
    var compare = prices.compare;
    var onSale  = prices.onSale;
    var priceUnit = prices.showM2Price ? 'x m²' : '';

    return html`<a class="ais-autocomplete__product" href="${url}">
      <div class="epa-aa-image">
        <img src="${image}" alt="${title}" loading="lazy" style="${image ? '' : 'display:none'}" />
      </div>
      <div class="epa-aa-content">
        <p class="epa-aa-vendor" style="${vendor ? '' : 'display:none'}">${vendor}</p>
        <h4 class="epa-aa-title">${title}</h4>
        <div class="epa-aa-price" data-epa-price-handle="${getHandle(hit)}" style="${price ? '' : 'display:none'}">
          <span class="epa-aa-price-current">${price}</span>
          <span class="epa-aa-price-unit" style="${priceUnit ? '' : 'display:none'}">${priceUnit}</span>
          <span class="epa-aa-price-compare" style="${onSale && compare ? '' : 'display:none'}"><s>${compare}</s></span>
        </div>
      </div>
    </a>`;
  }

  /* Fallback item template for the (unexpected) case where the autocomplete
   * hook is invoked without a templateOptions.html helper — keeps the
   * dropdown functional, just without VDOM-diffed markup. */
  function buildAutoItemString(hit) {
    var title   = hit.title || hit.name || '';
    var vendor  = hit.vendor || '';
    var url     = getUrl(hit);
    var image   = getImage(hit);
    var prices  = getHitPrices(hit);
    var price   = prices.price;
    var compare = prices.compare;
    var onSale  = prices.onSale;
    var priceUnit = prices.showM2Price ? ' x m²' : '';

    var imgHtml = image
      ? '<img src="' + esc(image) + '" alt="' + esc(title) + '" loading="lazy">'
      : '';

    var priceHtml = price
      ? '<div class="epa-aa-price" data-epa-price-handle="' + esc(getHandle(hit)) + '"><span class="epa-aa-price-current">' + price + '</span>'
        + (priceUnit ? ' <span class="epa-aa-price-unit">' + priceUnit.trim() + '</span>' : '')
        + (onSale && compare ? ' <span class="epa-aa-price-compare"><s>' + compare + '</s></span>' : '')
        + '</div>'
      : '';

    return '<a class="ais-autocomplete__product" href="' + esc(url) + '">'
      + '<div class="epa-aa-image">' + imgHtml + '</div>'
      + '<div class="epa-aa-content">'
        + (vendor ? '<p class="epa-aa-vendor">' + esc(vendor) + '</p>' : '')
        + '<h4 class="epa-aa-title">' + esc(title) + '</h4>'
        + priceHtml
      + '</div>'
    + '</a>';
  }

  /* ------------------------------------------------------------------
   * Hook handlers
   * ------------------------------------------------------------------ */
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(defaultTemplate, hit, html, components) {
    try {
      // hit may be wrapped inside { hit } or { item } by some Algolia versions
      var h = (hit && (hit.hit || hit.item)) ? (hit.hit || hit.item) : hit;
      if (!h || typeof h !== 'object') h = {};
      return buildCard(h);
    } catch (err) {
      console.warn('[Algolia Hook] InstantSearch error:', err);
      return defaultTemplate;
    }
  });

  // handler(defaultTemplate, templateOptions) — the hit/product data lives
  // at templateOptions.item (NOT a 3rd positional arg — confirmed via
  // runtime inspection; the 3rd positional arg is an unrelated flag).
  // templateOptions.html is the tagged-template helper.
  algoliaShopify.hooks.registerHook('beforeAutocompleteProductTemplate', function(defaultTemplate, templateOptions) {
    try {
      var htmlFn = templateOptions && typeof templateOptions.html === 'function' ? templateOptions.html : null;
      var raw = templateOptions && templateOptions.item;
      if (!raw || typeof raw !== 'object') raw = {};
      return htmlFn ? buildAutoItem(htmlFn, raw) : buildAutoItemString(raw);
    } catch (err) {
      console.warn('[Algolia Hook] Autocomplete error:', err);
      return defaultTemplate;
    }
  });

  function parseCanonicalPriceResponse(responseText) {
    var text = String(responseText || '').replace(/^\uFEFF/, '').trim();
    var sectionHtml = text;
    if (text.charAt(0) === '{') {
      var sections = JSON.parse(text);
      sectionHtml = sections['epa-price-data'] || sections[Object.keys(sections)[0]] || '';
    }

    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var node = parsed.querySelector('[data-epa-price]') || parsed.querySelector('#epa-price-data');
    if (!node) throw new Error('EPA price data missing from section response');

    var showM2Price = node.getAttribute('data-show-conversion') === 'true';
    var m2Price = node.getAttribute('data-price-m2-formatted') || '';
    var price = showM2Price && m2Price ? m2Price : (node.getAttribute('data-price-formatted') || '');
    var m2Compare = node.getAttribute('data-compare-m2-formatted') || '';
    var compare = showM2Price && m2Compare ? m2Compare : (node.getAttribute('data-compare-formatted') || '');

    return {
      price: price,
      compare: compare,
      onSale: !!compare,
      showM2Price: showM2Price && !!m2Price
    };
  }

  function fetchCanonicalPrice(handle) {
    if (!handle) return Promise.resolve(null);
    if (canonicalPriceCache[handle]) return Promise.resolve(canonicalPriceCache[handle]);
    if (canonicalPriceRequests[handle]) return canonicalPriceRequests[handle];

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '?section_id=epa-price-data';
    canonicalPriceRequests[handle] = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Price section request failed: ' + response.status);
        return response.text();
      })
      .then(parseCanonicalPriceResponse)
      .then(function (pricing) {
        canonicalPriceCache[handle] = pricing;
        return pricing;
      })
      .catch(function (error) {
        console.warn('[Algolia] Could not load canonical product price for ' + handle, error);
        return null;
      })
      .then(function (pricing) {
        delete canonicalPriceRequests[handle];
        return pricing;
      });

    return canonicalPriceRequests[handle];
  }

  function appendPriceUnit(parent) {
    var unit = document.createElement('span');
    unit.className = 'price-unit';
    unit.textContent = 'x m²';
    parent.appendChild(unit);
  }

  function updateAlgoliaPrice(node, pricing) {
    if (!node || !pricing || !pricing.price) return;

    if (node.classList.contains('epa-aa-price')) {
      node.style.display = '';
      var current = node.querySelector('.epa-aa-price-current');
      var unit = node.querySelector('.epa-aa-price-unit');
      var compare = node.querySelector('.epa-aa-price-compare');
      if (current) current.textContent = pricing.price;
      if (unit) {
        unit.textContent = pricing.showM2Price ? 'x m²' : '';
        unit.style.display = pricing.showM2Price ? '' : 'none';
      }
      if (compare) {
        compare.textContent = '';
        compare.style.display = pricing.onSale ? '' : 'none';
        if (pricing.onSale) {
          var strike = document.createElement('s');
          strike.textContent = pricing.compare;
          compare.appendChild(strike);
        }
      }
      return;
    }

    node.classList.toggle('f-price--on-sale', pricing.onSale);
    var regular = node.querySelector('.f-price__regular .f-price-item--regular');
    var sale = node.querySelector('.f-price__sale .f-price-item--sale');
    var compareAt = node.querySelector('.f-price__sale .f-price-item--regular');

    if (regular) {
      regular.textContent = pricing.onSale ? '' : pricing.price;
      if (!pricing.onSale && pricing.showM2Price) appendPriceUnit(regular);
    }
    if (sale) {
      sale.textContent = pricing.onSale ? pricing.price : '';
      if (pricing.onSale && pricing.showM2Price) appendPriceUnit(sale);
    }
    if (compareAt) {
      compareAt.textContent = '';
      if (pricing.onSale) {
        var strikeAt = document.createElement('s');
        strikeAt.textContent = pricing.compare;
        compareAt.appendChild(strikeAt);
        if (pricing.showM2Price) appendPriceUnit(compareAt);
      }
    }
  }

  function enrichAlgoliaPrices() {
    // The autocomplete dropdown re-renders via VDOM diffing (Preact), which
    // can reuse the SAME physical DOM node for a DIFFERENT product between
    // keystrokes — only its attributes/text get rewritten in place, no
    // element is added or removed. A plain boolean "already loaded" flag
    // on the node would then survive the handoff and permanently block the
    // correction for whatever new product that node now represents (the
    // node "remembers" it was already resolved, for the wrong handle).
    // So the loaded/loading state is keyed by the handle itself, and we
    // re-verify the node's handle hasn't changed again before applying a
    // fetch result that may have resolved after the node was recycled.
    document.querySelectorAll('[data-epa-price-handle]').forEach(function (node) {
      var handle = node.getAttribute('data-epa-price-handle');
      if (!handle) return;
      if (node.dataset.epaPriceLoadedFor === handle) return;
      if (node.dataset.epaPriceLoadingFor === handle) return;
      node.dataset.epaPriceLoadingFor = handle;
      fetchCanonicalPrice(handle).then(function (pricing) {
        if (node.dataset.epaPriceLoadingFor === handle) delete node.dataset.epaPriceLoadingFor;
        if (!node.isConnected) return;
        if (node.getAttribute('data-epa-price-handle') !== handle) return;
        node.dataset.epaPriceLoadedFor = handle;
        updateAlgoliaPrice(node, pricing);
      });
    });
  }

  var algoliaPriceObserver = new MutationObserver(enrichAlgoliaPrices);
  // attributes/attributeFilter is required in addition to childList: a
  // recycled node (see enrichAlgoliaPrices above) only gets its
  // data-epa-price-handle attribute rewritten in place, which childList
  // alone would never report.
  algoliaPriceObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-epa-price-handle']
  });
  enrichAlgoliaPrices();

});

/* ------------------------------------------------------------------
 * Facets toggle button (.ais-facets-button) — Spanish label + mobile
 * placement inside the results toolbar row.
 *
 * Label: its "Show filters" / "Hide filters" text is generated directly
 * by Algolia's own widget JS, not theme translation files, so it can't
 * be relabeled via Liquid or a hook, and it flips with open/closed state
 * so a static CSS content swap isn't enough either.
 *
 * Placement: on mobile the button and .ais-search-header (result count /
 * sort / view-toggle) are meant to read as one toolbar row, but they're
 * siblings of different parents in the DOM (.ais-facets-button is a
 * direct child of .ais-page; .ais-search-header is nested inside
 * .ais-block) — no CSS ordering/positioning trick merges elements from
 * different parents without becoming fragile to layout reflow, so we
 * physically move the node instead (position:fixed for the open state
 * doesn't care about DOM ancestry, so this is safe). Restores it to its
 * original spot if the viewport grows past the drawer breakpoint.
 * ------------------------------------------------------------------ */
(function () {
  var LABEL_CLOSED = 'Mostrar filtros';
  var LABEL_OPEN = 'Ocultar filtros';
  var MOBILE_QUERY = '(max-width: 1279.98px)';

  function watchFacetsButton(btn, panel, header) {
    var btnObserver;
    var mq = window.matchMedia(MOBILE_QUERY);
    var originalParent = btn.parentNode;
    var originalNextSibling = btn.nextSibling;

    function isOpen() {
      return panel.classList.contains('ais-facets__shown');
    }

    function relabel() {
      var desired = isOpen() ? LABEL_OPEN : LABEL_CLOSED;
      btn.classList.toggle('ais-facets-button--open', isOpen());
      if (btn.textContent.trim() === desired) return;
      if (btnObserver) btnObserver.disconnect();
      btn.textContent = desired;
      if (btnObserver) {
        btnObserver.observe(btn, { childList: true, characterData: true, subtree: true });
      }
    }

    function placeForViewport() {
      if (mq.matches) {
        if (header.firstElementChild !== btn) {
          header.insertBefore(btn, header.firstChild);
        }
      } else if (btn.parentNode !== originalParent) {
        originalParent.insertBefore(btn, originalNextSibling);
      }
    }

    btnObserver = new MutationObserver(relabel);
    btnObserver.observe(btn, { childList: true, characterData: true, subtree: true });
    new MutationObserver(relabel).observe(panel, { attributes: true, attributeFilter: ['class'] });

    if (mq.addEventListener) {
      mq.addEventListener('change', placeForViewport);
    } else if (mq.addListener) {
      mq.addListener(placeForViewport); // Safari < 14
    }

    relabel();
    placeForViewport();
  }

  function tryInit(bodyObserver) {
    var btn = document.querySelector('.ais-facets-button');
    var panel = document.querySelector('.ais-facets');
    var header = document.querySelector('.ais-search-header');
    if (!btn || !panel || !header) return;
    bodyObserver.disconnect();
    watchFacetsButton(btn, panel, header);
  }

  var bodyObserver = new MutationObserver(function () { tryInit(bodyObserver); });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
  tryInit(bodyObserver);
})();

/* ==========================================================
   ALGOLIA - FORMATO DE PRECIOS CRC
   Solo modifica la presentación visual.
   No modifica valores ni filtros de Algolia.
   ========================================================== */

(function () {
  'use strict';

  function formatCRC(value) {
  var number = String(value).replace(/[^\d]/g, '');

  if (!number) {
    return value;
  }

  return '₡' + Number(number).toLocaleString('en-US').replace(/,/g, '.');
}

  function formatAlgoliaPriceRange() {

    /* -----------------------------------------
       1. SLIDER DE PRECIO
       ----------------------------------------- */

    document.querySelectorAll(
      '.ais-RangeSlider .rheostat-tooltip, .ais-RangeSlider .rheostat-value'
    ).forEach(function (element) {

      var value = element.textContent.trim();

      if (!value || value.indexOf('₡') === 0) {
        return;
      }

      element.textContent = formatCRC(value);
    });


    /* -----------------------------------------
       2. RANGOS PREDEFINIDOS DE PRECIO
       Ejemplo:
       $1,000 - $1,500
       ----------------------------------------- */

    document.querySelectorAll(
      '.ais-RefinementList label.ais-RefinementList-label'
    ).forEach(function (label) {

      var textNode = Array.from(label.childNodes).find(function (node) {
        return node.nodeType === Node.TEXT_NODE &&
               node.textContent.trim().match(/^\$/);
      });

      if (!textNode) {
        return;
      }

      var text = textNode.textContent.trim();

      if (!/^\$[\d,]+(?:\s*-\s*\$[\d,]+)?$/.test(text)) {
        return;
      }

      var formatted = text.replace(/\$([\d,]+)/g, function (_, number) {
        return '₡' + Number(number.replace(/,/g, '')).toLocaleString('es-CR');
      });

      textNode.textContent = formatted + ' ';
    });
  }


  /* Ejecutar cuando la página carga */
  formatAlgoliaPriceRange();


  /* Algolia vuelve a dibujar los filtros dinámicamente */
  var observer = new MutationObserver(function () {
    formatAlgoliaPriceRange();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();